import React from 'react';
import { NavLink } from 'react-router-dom';
import { reactLocalStorage } from 'reactjs-localstorage';
import Table from 'react-bootstrap/Table';
import { FaPencilAlt, FaOsi } from 'react-icons/fa';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

import ModulAPI from '../../../api/ModulAPI';
import Util from '../../../util/Util';
import DefaultControllerConst from '../../../util/DefaultControllerConst';
import withRouter from '../../../util/WithRouter';
import Display from '../../../util/Display';
import ApiUiController from '../../../controller/ApiUiController';
import Const from '../../../util/Constants';
import { Badge } from 'react-bootstrap';

class ModuleList extends React.Component {

  constructor(props) {
    super(props);
    this.state = { inApiCall: false, popup: false, name: '' };
    this.path = this.props.match.path;

    this.module = '';
    this.modules = reactLocalStorage.getObject(Const.Model);

    const modelCat = this.modules.field_key;
    const model = this.modules.module;
    this.List = Util.isAllow(model.permission, Const.PermView);
    this.Update = Util.isAllow(model.permission, Const.PermUpdate);
    this.CatList = Util.isAllow(modelCat.permission, Const.PermView);
  }

  show = key => {
    this.module = key;
    this.setState({ ...this.state, name: this.modules[key].model_name, popup: true });
  };
  hide = () => this.setState({ ...this.state, popup: false });
  nameChange = event => this.setState({ ...this.state, name: event.target.value });

  submit = () => {
    this.setState({ ...this.state, popup: false });
    Util.confirmAlert('Rename', `Are you sure you want to change name to ${this.state.name}`,
      'Rename', 'No', () => {
        this.setState({ ...this.state, inApiCall: true });
        const module = {
          model_no: this.modules[this.module].model_no,
          model_name: this.state.name
        };
        ModulAPI.save(module, this.onSuccess, this.onFail);
      });
  };
  onFail = (res) => {
    const message = res.message ? JSON.stringify(res.message) : 'Something went wrong';
    Util.showError(message);
    this.setState({ ...this.state, inApiCall: false });
  };
  onSuccess = () => {
    this.setState({ ...this.state, inApiCall: false });
    Util.showNotification('Successful', 'Name changed successfully.', 'success');
    this.props.onModuleChanged();
  };

  render() {
    if (!this.List) return null;

    let moduleUI = Object.keys(this.modules).map((key, _i) => (
      <tr key={`module_${key}`}>
        <td>{_i + 1}</td>
        <td>{this.modules[key].model_name}</td>
        <td>{key}</td>
        <td>{Display.ModelLabelValue('user', this.modules[key].updated_by)}</td>
        <td>{Util.serverStringToDisplayDateTime(this.modules[key].updated_date)}</td>
        <td className="btnactionflex">
          {this.props.context === DefaultControllerConst.Global && this.Update &&
            <Badge variant="warning" size='sm' onClick={() => this.show(key)} className='m-1 p-2 text-white' color='white'> <FaPencilAlt className="actionbtnp" color='#fff' /> Rename </Badge>
          }
          {this.CatList &&
            <NavLink to={`${this.path}/field/${this.modules[key].model_no}`}>
              <Badge variant="primary" size='sm' className='m-1 p-2 text-white' color='white'> <FaOsi className="actionbtnp mx-1" color='#fff' /> Fields </Badge>
            </NavLink>
          }
        </td>
      </tr>
    ));
    if (moduleUI.length === 0) moduleUI = <tr><td colSpan="6"> No Records Found </td></tr>;

    return (
      <>
        <Modal show={this.state.popup} onHide={this.hide} size="md"
          aria-labelledby="contained-modal-title-vcenter" centered>

          <Modal.Header closeButton>
            <Modal.Title id="contained-modal-title-vcenter"> Module List </Modal.Title>
          </Modal.Header>

          <Modal.Body>
            <Form>
              <Row className="row-cols-2 colmr">
                <Col xs={12}>
                  <Form.Label>Name</Form.Label>
                  <Form.Control type="text" placeholder="Name"
                    className="mr-sm-2" value={this.state.name}
                    onChange={this.nameChange} />
                </Col>
              </Row>
            </Form>
          </Modal.Body>
          <Modal.Footer> <Button onClick={this.submit}>Submit</Button> </Modal.Footer>
        </Modal>

        <div className="sectionlist pt-3">
          <div className="container-fluid">
            <div className="row"> <div className="col-md-6 pb-3"> <h3>Modules</h3> </div>
              <div className="col-md-12">
                <Table striped bordered hover>
                  <thead>
                    <tr>
                      <th>No</th> <th>Name</th> <th>Key</th> <th>Updated By</th>
                      <th>Updated Date</th> <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    <ApiUiController inApiCall={this.props.inApiCall}>
                      {moduleUI}
                    </ApiUiController>
                  </tbody>
                </Table>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}
export default withRouter(ModuleList);